/*
  Vybrance Hero Slideshow
  Replaces Swiper 11 (was ~150KB gzipped, ~23s CPU on Lighthouse).
  Supports: fade + slide effects, autoplay, loop, prev/next, pagination,
  pause/play, hover-pause, keyboard, prefers-reduced-motion, Shopify
  design-mode block selection. CSS classnames kept compatible with the
  prior markup (.swiper-wrapper, .swiper-slide, .swiper-pagination-bullet).
*/
(function () {
  var INITED = 'veHeroInited';

  function init(root) {
    if (!root || root.dataset[INITED] === '1') return;
    root.dataset[INITED] = '1';

    var swiperEl = root.querySelector('.hero__swiper');
    if (!swiperEl) return;

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    var slides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
    if (!slides.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var effect = reduced ? 'slide' : (swiperEl.dataset.effect || 'fade');
    var autoplay = swiperEl.dataset.autoplay === 'true' && !reduced && slides.length > 1;
    var delay = parseInt(swiperEl.dataset.delay, 10) || 6000;
    var loop = swiperEl.dataset.loop === 'true';

    root.classList.add('hero--effect-' + effect);
    if (reduced) root.classList.add('hero--reduced-motion');

    var prev = root.querySelector('.hero__nav--prev');
    var next = root.querySelector('.hero__nav--next');
    var pp = root.querySelector('.hero__playpause');
    var pag = root.querySelector('.hero__pagination');

    var index = 0;
    var timer = null;
    var manuallyPaused = false;

    function setActive(i) {
      for (var j = 0; j < slides.length; j++) {
        var on = j === i;
        slides[j].classList.toggle('is-active', on);
        if (on) {
          slides[j].removeAttribute('inert');
          slides[j].setAttribute('aria-hidden', 'false');
        } else {
          slides[j].setAttribute('inert', '');
          slides[j].setAttribute('aria-hidden', 'true');
        }
      }
      if (bullets) {
        for (var k = 0; k < bullets.length; k++) {
          bullets[k].classList.toggle('swiper-pagination-bullet-active', k === i);
          bullets[k].setAttribute('aria-current', k === i ? 'true' : 'false');
        }
      }
      if (effect === 'slide' && wrapper) {
        wrapper.style.transform = 'translate3d(' + (-100 * i) + '%, 0, 0)';
      }
      index = i;
    }

    function go(target) {
      var n = slides.length;
      var nextIdx;
      if (loop) {
        nextIdx = ((target % n) + n) % n;
      } else {
        nextIdx = Math.max(0, Math.min(n - 1, target));
      }
      if (nextIdx === index) return;
      setActive(nextIdx);
    }

    function start() {
      stop();
      if (!autoplay || manuallyPaused) return;
      timer = window.setInterval(function () { go(index + 1); }, delay);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    function resetAutoplay() {
      if (autoplay && !manuallyPaused) start();
    }

    // Pagination
    var bullets = null;
    if (pag && slides.length > 1) {
      bullets = [];
      for (var i = 0; i < slides.length; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'swiper-pagination-bullet' + (idx === 0 ? ' swiper-pagination-bullet-active' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.setAttribute('aria-current', idx === 0 ? 'true' : 'false');
          b.addEventListener('click', function () { go(idx); resetAutoplay(); });
          pag.appendChild(b);
          bullets.push(b);
        })(i);
      }
    }

    // Initial paint
    setActive(0);

    // Nav
    if (prev) prev.addEventListener('click', function () { go(index - 1); resetAutoplay(); });
    if (next) next.addEventListener('click', function () { go(index + 1); resetAutoplay(); });

    // Play/pause
    if (pp && autoplay) {
      pp.addEventListener('click', function () {
        var pressed = pp.getAttribute('aria-pressed') === 'true';
        if (pressed) {
          manuallyPaused = false;
          start();
          pp.setAttribute('aria-pressed', 'false');
          pp.setAttribute('aria-label', 'Pause slideshow');
        } else {
          manuallyPaused = true;
          stop();
          pp.setAttribute('aria-pressed', 'true');
          pp.setAttribute('aria-label', 'Play slideshow');
        }
      });
    } else if (pp) {
      pp.hidden = true;
    }

    // Pause on hover (matches prior Swiper pauseOnMouseEnter behavior)
    if (autoplay) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', function () { if (!manuallyPaused) start(); });
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget) && !manuallyPaused) start();
      });
    }

    // Keyboard (only when the slideshow has focus within)
    root.addEventListener('keydown', function (e) {
      if (!root.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); resetAutoplay(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); resetAutoplay(); }
    });

    // Pause when tab/page hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (!manuallyPaused) start();
    });

    // Shopify theme editor: jump to selected slide
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (!root.contains(e.target)) return;
        var slide = e.target.closest('.hero__slide');
        if (!slide) return;
        var idx = slides.indexOf(slide);
        if (idx < 0) return;
        stop();
        manuallyPaused = true;
        if (pp) {
          pp.setAttribute('aria-pressed', 'true');
          pp.setAttribute('aria-label', 'Play slideshow');
        }
        setActive(idx);
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        if (!root.contains(e.target)) return;
        manuallyPaused = false;
        if (pp) {
          pp.setAttribute('aria-pressed', 'false');
          pp.setAttribute('aria-label', 'Pause slideshow');
        }
        if (autoplay) start();
      });
    }

    if (autoplay) start();
  }

  function initAll(scope) {
    var heroes = (scope || document).querySelectorAll('.hero');
    for (var i = 0; i < heroes.length; i++) init(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
